const state = {
    typeDocumentStarassignment:[],
    typeCategoryStarAssignment:{},
    typeStar:[],
    cardsList: [],
    loading: false,
    template:[],
    templateDownload:null,
    postTemplate:null,

};

export default state;